import React, { FC } from 'react'
import classNames from 'classnames'
import { PaddedContainer } from '@/atoms/PaddedContainer'

interface CollectiblesPlayerPlaceHolderProps {
  className?: string
}

export const CollectiblesPlayerPlaceHolder: FC<CollectiblesPlayerPlaceHolderProps> = ({ className }) => (
  <>
    <div
      aria-label="Loading Video..."
      className={classNames(
        'w-full aspect-w-16 aspect-h-9 lg:aspect-h-unset lg:aspect-w-unset lg:h-[60vh] bg-black',
        className,
      )}
    />
    <PaddedContainer fluid>
      <div className="flex w-full flex-col-reverse justify-between py-4 sm:flex-row sm:space-x-4 sm:space-y-0">
        <div className="flex w-full flex-col space-y-3 pt-2 sm:pt-0">
          <div className="h-[21px] w-full rounded bg-black" />
          <div className="h-[21px] w-full rounded bg-black" />
          <div className="h-[42px] w-full rounded bg-black" />
        </div>
        <div className="flex w-full basis-1/4 flex-col space-y-2">
          <div className="h-[40px] w-[128px] self-end rounded bg-black"> </div>
          <div className="h-[40px] w-full self-end rounded bg-black sm:w-[128px]"> </div>
        </div>
      </div>
    </PaddedContainer>
  </>
)
